<template>

    <div class="container">


        <div class="handle-box-search">

            <el-row class="head-search">


                <el-col :span="12" style="margin-bottom: 10px;">
                    <span class="title">兑换码:</span>
                    <el-input
                            placeholder="请输入兑换码"
                            v-model="search_data.wallet_key"
                            style="width: 350px;"
                    ></el-input>
                </el-col>

                <el-col :span="12" style="margin-bottom: 10px;">
                    <span class="title">兑换券名称:</span>

                    <el-input
                            placeholder="请输入兑换券名称"
                            v-model="search_data.title"
                            style="width: 200px;"
                    ></el-input>
                </el-col>


            </el-row>


            <el-row class="head-search">


                <el-col :span="12" style="margin-bottom: 10px;">
                    <span class="title">创建时间:</span>

                    <el-date-picker
                            v-model="time"
                            type="daterange"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            @change="timeChange"
                    >
                    </el-date-picker>
                </el-col>


            </el-row>


            <el-button type="primary" icon="el-icon-search" @click="walletkeyLogLists">搜索</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
            <el-button :icon="!progress_show?'el-icon-setting':'el-icon-loading'" @click="toExport" :disabled="progress_show">{{progress_show?'正在导出...':'导出'}}</el-button>
        </div>


        <div class="searchInfo">
            <!-- 表格 -->
            <div>

                <el-table
                        :data="tableData"
                        style="width: 100%"
                        ref="multipleTable"
                        header-cell-class-name="table-header"
                >


                    <el-table-column
                            prop="wallet_key"
                            label="兑换码"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="title"
                            label="兑换券名称"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="price"
                            label="兑换金额"
                    >
                        <template slot-scope="scope">
              <span style="color: rgb(233, 161, 6);">
                {{scope.row.price}}元
              </span>
                        </template>
                    </el-table-column>


                    <el-table-column
                            prop="city.name"
                            label="所属城市"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="consumer.name"
                            label="领取人"
                    >
                    </el-table-column>

                    <el-table-column
                            prop="consumer.phone"
                            label="手机号"
                    >
                    </el-table-column>


                    <el-table-column
                            prop="time.YmdHis"
                            label="领取时间"
                    >
                    </el-table-column>

                </el-table>
            </div>

            <!-- 分页组件 -->
            <div class="pagination">
                <pages
                        :search_data="search_data"
                        :result_data="result_data"
                        @pages_function="pages_function"
                ></pages>
            </div>

        </div>
    </div>

</template>

<script>
    import bus from '../../common/bus';

    var _this;
    export default {
        data() {
            return {

                // 存放表格数据
                tableData: [],

                progress_show:false,

                excelData: [],

                excelHead: [],

                time:'',

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                    title: '',
                    time_fixed: '',
                    wallet_key: ''
                },


                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    }
                }
            };
        },
        created() {
            _this = this;

            // 接收http.js文件传来的通知(接口请求报错时将导出按钮变为可点击状态)
            bus.$on('btnStatus', msg => {
                _this.progress_show = false;
            });

          
        },

        methods: {

            toExport(){
                _this.progress_show = true;
                _this.search_data.page = 1;
                _this.getExcelData();
            },
            // 导出excel方法
            exportData() {
                const {
                    export_json_to_excel
                } = require('@/vendor/Export2Excel');
                const tHeader = ['兑换码','兑换券名称','兑换金额', '所属城市', '领取人', '手机号', '领取时间'];
                const filterVal = ['wallet_key','title','price','city','consumer','phone','time'];
                const list = this.excelData;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, 'fileName');
            },

            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },

            getExcelData(){
                _this.$post(
                    "/walletkey/ConsumerwalletkeyCsv",
                    {
                        page:_this.search_data.page,
                        title:_this.search_data.title,
                        time_fixed:_this.search_data.time_fixed,
                        wallet_key:_this.search_data.wallet_key,
                    }
                ).then(res => {



                    if (this.$route.path == '/walletkeylog') {


                        // 导出excel的空数组中添加数据
                        for (let i = 0; i < res.data.list.length; i++) {
                            // console.log(res.data.list[i]);
                            _this.excelData.push({
                                'wallet_key': res.data.list[i].wallet_key,
                                'title': res.data.list[i].title,
                                'price': res.data.list[i].price,
                                'city': res.data.list[i].city.name,
                                'consumer': res.data.list[i].consumer.name,
                                'phone': res.data.list[i].consumer.phone,
                                'time': res.data.list[i].time.YmdHis
                            });


                        }



                        if (res.data.page * res.data.limit < res.data.count) {


                            _this.search_data.page = res.data.page + 1;


                            _this.getExcelData();

                        } else {
                            // console.log(_this.excelData);

                            // 将数据导出execl
                            _this.exportData();

                            _this.search_data.page = 1;

                            // 清空数据
                            _this.excelData = [];

                            _this.progress_show = false;


                        }

                    } else {

                        _this.progress_show = false;

                    }



                }).catch((err) => {

                })

            },


            timeChange(val) {
                if (val != null) {
                    _this.search_data.time_fixed = JSON.stringify(['between'].concat(val));
                } else {
                    _this.search_data.time_fixed = '';
                }
            },


            
            walletkeyLogLists() {
                if(_this.search_data.title==''&&_this.search_data.time_fixed==''&&_this.search_data.wallet_key=='') {
                    this.$message.error("查询条件不能为空");

                } else {
                    _this
                    .$post('/walletkey/ConsumerwalletkeyLists', _this.search_data, _this.search_rules)
                    .then((res) => {
                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;
                    })
                    .catch((err) => {
                    });

                }
              
                
            },
            //翻页组件的回调
            pages_function(search_data) {
                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.walletkeyLogLists();
            },


            // 刷新按钮
            refresh() {
                this.$router.go(0);
            }
        }
    };
</script>

<style scoped>
</style>
